<template>
  <transition name="transition-fade">
    <div ref="progressWrapper" class="absolute top-0 left-0 w-full h-full z-10 bg-white">
      <div class="flex justify-center items-center absolute top-0 left-0 w-full h-full">
        <transition name="transition-fade">
          <div v-show="loadingCompleted">
            <svg class="checkmark_animation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="checkmark_animation__circle" cx="26" cy="26" r="25" fill="none"/>
              <path class="checkmark_animation__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
            <p class="text-center text-sm text-gray-700">{{ $t("message.progressLoader.finishedLabel") }}</p>
          </div>
        </transition>
        <div v-show="!loadingCompleted" class="text-center" data-progress="0">
          <div class="mt-2">
            <p class="text-sm">{{ $t("message.progressLoader.uploadingLabel") }}</p>
            <p class="text-lg">{{ percentageCompleted + '%' }}</p>
          </div>
        </div>
      </div>
      <div class="absolute left-0 h-full top-0 w-full">
        <svg v-show="!loadingCompleted" class="animate-spin" width="100%" height="100%" viewbox="0 0 50% 50%" xmlns="http://www.w3.org/2000/svg">
          <circle style="fill: none; stroke: rgb(209, 213, 219); stroke-width: 5;"
                  cx="50%" cy="50%" r="40%"></circle>
          <circle ref="progressCircle"
                  class="stroke-gray-400"
                  style="fill: none;
                  stroke: hsla(201, 96%, 37%, 1);
                  stroke-width: 5;
                  stroke-dasharray: 0 999;
                  stroke-dashoffset: 0px;
                  transition: stroke-dasharray 0.5s ease-out;"
                  cx="50%" cy="50%" r="40%"></circle>
        </svg>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Loader.vue
 */
export default {
  props: {
    percentageCompleted: {
      type: Number,
      default: 0,
    },
  },

  data () {
    return {
      loadingCompleted: false
    }
  },

  watch: {
    percentageCompleted: function (percentageCompleted) {
      // Fills the circle to the percentage accrued
      const progressWrapperHeight = this.$refs.progressWrapper.offsetHeight
      const strokeVal = progressWrapperHeight / 39.5;
      this.updateProgressCircle(percentageCompleted * strokeVal)
      // run animations on completion
      if (percentageCompleted >= 100) {
        this.showCompletedState()
            .then(this.hideProgressLoader())
      }
    }
  },

  methods: {
    updateProgressCircle(newStrokeValue) {
      const progressCircle = this.$refs.progressCircle
      progressCircle.style.strokeDasharray = newStrokeValue + ' 999';
    },
    showCompletedState () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.loadingCompleted = true
          resolve(true)
        }, 500)
      });
    },

    hideProgressLoader () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.$emit('hideProgressLoader', true)
          resolve(true)
        }, 3000)
      });
    }
  }
}
</script>
